import { Heading } from "@medoma/components/Heading/Heading";
import { Loading } from "@medoma/components/Loading/Loading";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import * as Sentry from "@sentry/react";
import { Trans, useLingui } from "@lingui/react/macro";
import { GoBackLink } from "@/routes/profile/goBackLink";
import styles from "./review.module.scss";
import { useTallyFormId } from "./tally/useTallyFormId";
import { useLocation, useNavigate } from "react-router";
import { useUserProfile } from "@/utils/useUserProfile";
import { usePatient } from "@/api/patient";
import TallyForm from "./tally/TallyForm";

const TIMEOUT_BEFORE_NAVIGATION = 5000;
const LANDING_PAGE_AFTER_SUCCESSFUL_FORM_SUBMISSION = "/profile";

export const Review = () => {
  const { t } = useLingui();
  const tallyFormId = useTallyFormId();
  const navigate = useNavigate();
  const location = useLocation();
  const { organization } = useUserProfile();
  const { data: patient, isPending, isError, error } = usePatient();

  const navigateAfterTimeout = () => {
    const reviewFormLocation = location.pathname;

    setTimeout(() => {
      if (window.location.pathname === reviewFormLocation) {
        void navigate(LANDING_PAGE_AFTER_SUCCESSFUL_FORM_SUBMISSION);
      }
    }, TIMEOUT_BEFORE_NAVIGATION);
  };

  if (isPending) {
    return <Loading message={t`Hämtar utvärdering`} />;
  }

  if (isError) {
    Sentry.captureException(error);
    return <ErrorMessage message={t`Kunde inte hämta utvärderingen`} />;
  }

  return (
    <>
      <GoBackLink />
      <Heading level="h1" margin="top-and-bottom">
        <Trans>Utvärdering</Trans>
      </Heading>
      <div className={styles.container}>
        <TallyForm
          formId={tallyFormId}
          onSubmission={navigateAfterTimeout}
          organization={organization}
          siteId={patient.site.id}
        />
      </div>
    </>
  );
};
